import { useState, useEffect, useLayoutEffect } from 'react'

import {
  Button,
  CheckBox,
  Col,
  Grid,
  Input,
  Picker,
  Row,
  Span,
  TextArea,
  ChipInput,
  Card
} from 'components'
import SimpleCollapse from 'components/Collapse/SimpleCollapse'
import { useLoading, useModal } from 'hooks'
import { useLocation } from 'react-router-dom'
import { useHistory } from 'react-router-dom'
import { ContractServices } from 'services/NGT/Contract'
import { SPACING } from 'utils'
interface location {
  request_body: any
  name: any
  hash: string
  pathname: string
  search: string
  state: {
    name: string
    request_body: any
  }
}
export interface Contrato {
  idContrato: number
  contratoPrincipalId?: any
  fornecedorId: number
  empresaId: number
  centroPlantaId: number
  tipoCreId: number
  setorId: number
  contraparteUsuarioId: number
  compradorUsuarioId: number
  unidadeGestoraId: number
  cdContrato: string
  cdContratoPrincipal: string
  cnpj: string
  nmFornecedor: string
  nmEmpresa: string
  nmCentro: string
  txObjetoContrato: string
  nmCRE: string
  txCno?: string
  flSocio: boolean
  dtVigenciaInicio: Date
  dtVigenciaFim: Date
  dtVigInicoReal: Date
  dtVigFimReal: Date
  vlContratual: number
  nmSetor: string
  flRecorrente: boolean
  flEncerrado: boolean
  flDenuncia: boolean
  flAlerta: boolean
  flSubcontrato: boolean
  txDenuncia?: any
  txAlerta?: any
  matriculaContraparte?: any
  nmContraparte: string
  ramalContraparte: string
  emailContraparte: string
  contraparteSub: any[]
  matriculaComprador: string
  nmComprador: string
  ramalComprador: string
  emailComprador: string
  nmUnidadeGestora: string
  nmUnidade: string
  cdGrupoMercadoria: string
  cdHierarquiaProd: string
  txObservacao: string
  txEmail: any[]
}

export const ViewContract: React.FC = () => {
  const { setLoading } = useLoading()
  const { showModal } = useModal()
  const history = useHistory()
  const location = useLocation<location>()
  const requestBodyId = location?.state?.request_body?.id
  const [contractData, setContractData] = useState<Contrato>()
  const [unidadeGestora, setUnidadeGestora] = useState({
    diretoria: '',
    diretoriaExecutiva: '',
    gerencia: '',
    gerenciaGeral: ''
  })
  const inputsDiretoria = [
    'diretoriaExecutiva',
    'diretoria',
    'gerenciaGeral',
    'gerencia'
  ]

  useEffect(() => {
    const handleGetContract = () => {
      setLoading('loading')
      ContractServices()
        .GetContractById(requestBodyId)
        .then((response) => {
          setContractData(response.data)
          const unidade = response.data?.nmUnidade
          if (unidade === null) {
            return
          } else {
            const nomeUnidades = unidade.split('-')
            for (let n = 0; n < inputsDiretoria.length; n++) {
              if (nomeUnidades[n]) {
                setUnidadeGestora((prevState) => ({
                  ...prevState,
                  [inputsDiretoria[n]]: nomeUnidades[n]
                }))
              } else {
                setUnidadeGestora((prevState) => ({
                  ...prevState,
                  [nomeUnidades[n]]: ''
                }))
              }
            }
            setLoading('idle')
          }
        })
        .catch((err) =>
          showModal({
            handleConfirm: () => history.goBack(),
            hideButtonCancel: true,
            message: err.message || err.mensagem || 'Erro obter contrato',
            txtButtonConfirm: 'Voltar',
            type: 'error'
          })
        )
    }
    if (!location.state) {
      showModal({
        handleConfirm: () => history.push('/'),
        hideButtonCancel: true,
        message: 'Não foi possivel acessar pagina',
        txtButtonConfirm: 'Fechar',
        type: 'alert'
      })
    } else {
      handleGetContract()
    }
  }, [])

  return (
    <Card
      marginLeft={SPACING.spacing30}
      marginRight={SPACING.spacing10}
      marginBottom={SPACING.spacing100}
      padding={SPACING.spacing20}
      boxShadow={`0px -1px 32px rgba(50, 50, 71, 0.12), 0px 24px 32px rgba(50, 50, 71, 0.12)`}
      borderRadius={`0px 10px 0px 0px`}
    >
      {contractData && (
        <>
          <SimpleCollapse isExpanded={true} title="INFORMAÇÕES GERAIS">
            <Grid
              gridCols="1fr 1fr 2fr 2fr 2fr"
              gridGap={`0 ${SPACING.spacing20}`}
              margin={`0 0 ${SPACING.spacing30} 0`}
            >
              <Input
                disabled
                value={contractData.cnpj}
                label="CPF/CNPJ/Cód.Fornecedor"
                placeholder="Nº"
                mask={
                  contractData.cnpj && contractData.cnpj.length > 9 
                  ? ['###.###.###-##', '##.###.###/####-##']
                  : ['#########']
                }
              />
              <Input
                value={contractData.nmFornecedor}
                disabled
                label="Fornecedor"
                placeholder="Nº"
              />
              <Input
                value={contractData.nmEmpresa}
                disabled
                label="Empresa"
                placeholder="Nº"
              />
              <Input
                value={contractData.nmCentro}
                disabled
                label="Centro Selecionado"
                placeholder="Nº"
              />
              <Input
                disabled
                value={contractData.nmSetor}
                label="Negócio"
                placeholder="Negócio"
              />
            </Grid>
            <Grid
              gridCols="5fr 7FR"
              gridGap={`0 ${SPACING.spacing20}`}
              margin={`0 0 ${SPACING.spacing30} 0`}
            >
              <TextArea
                count={contractData.txObjetoContrato?.length}
                value={contractData.txObjetoContrato || ''}
                disabled
                required
                label="Objeto do contrato"
                placeholder=""
                maxLength={1000}
              />
            </Grid>
            <Grid
              gridCols="1fr 2fr 2fr"
              gridGap={`0 ${SPACING.spacing20}`}
              margin={`0 0 ${SPACING.spacing30} 0`}
            >
              <Input
                disabled
                value={contractData.nmCRE}
                label="CRE"
                placeholder="CRE"
              />
              <Input
                disabled
                value={contractData.txCno}
                label="CNO (Cadastro Nacional de Obras)"
                placeholder="CNO"
              />
              <CheckBox checked={contractData.flSocio} label="Sócio" />
            </Grid>
            <Grid
              gridCols="1fr 1fr 1fr 1fr 1fr  1fr 2fr "
              gridGap={`0 ${SPACING.spacing10}`}
              margin={`0 0 ${SPACING.spacing30} 0`}
            >
              <Picker
                value={contractData.dtVigenciaInicio}
                disabled
                label="Início Vigência Contrato"
              />
              <Picker
                disabled
                value={contractData.dtVigenciaFim}
                label="Fim Vigência Contrato"
              />
              <Picker
                value={contractData.dtVigInicoReal}
                disabled
                label="Início Vigência Real"
              />
              <Picker
                value={contractData.dtVigFimReal}
                disabled
                label="Fim Vigência Real"
              />
              <Input
                value={contractData.vlContratual}
                label="Valor Contratual"
                placeholder="Valor"
              />
              <Col>
                <Span text="Tipo" />
                <CheckBox
                  checked={contractData.flRecorrente}
                  label="Recorrente"
                />
              </Col>
              <Col>
                <Span text="Contrato" />
                <CheckBox
                  checked={contractData.flEncerrado}
                  label="Encerrado"
                />
              </Col>
            </Grid>

            <Grid
              gridCols="3fr 2fr 2fr "
              gridGap={`0 ${SPACING.spacing20}`}
              margin={`0 0 ${SPACING.spacing30} 0`}
            >
              <Col>
                <Span text="Notificação" />
                <Row>
                  <CheckBox
                    checked={contractData.flDenuncia}
                    label="Denúncia"
                  />
                  <CheckBox checked={contractData.flAlerta} label="Alerta" />
                  <CheckBox
                    checked={contractData.flSubcontrato}
                    label="Solicitação Subcontrato"
                  />
                </Row>
              </Col>
              <Input
                disabled
                value={contractData.txDenuncia}
                label="Denúncia"
                placeholder="Justifique"
                maxLength={300}
              />
              <Input
                disabled
                maxLength={300}
                value={contractData.txAlerta}
                label="Alerta"
                placeholder="Justifique"
              />
            </Grid>
            <Grid
              gridCols="1fr 2fr 1fr 3fr 1fr"
              gridGap={`0 ${SPACING.spacing20}`}
              margin={`0 0 ${SPACING.spacing30} 0`}
            >
              <Input
                value={contractData.matriculaContraparte}
                disabled
                label="Matrícula Contraparte"
                placeholder="Nº"
              />
              <Input
                disabled
                value={contractData.nmContraparte}
                label="Contraparte"
              />
              <Input
                disabled
                label="Ramal"
                value={contractData.ramalContraparte}
              />
              <Input
                disabled
                type="email"
                label="E-mail"
                value={contractData.emailContraparte}
              />
            </Grid>
            {contractData.contraparteSub &&
              contractData.contraparteSub.length > 0 &&
              contractData.contraparteSub.map((contraparteSub) => {
                return (
                  <Grid
                    key={contraparteSub.usuarioId}
                    gridCols="1fr 2fr 1fr 3fr 1fr"
                    gridGap={`0 ${SPACING.spacing20}`}
                    margin={`0 0 ${SPACING.spacing30} 0`}
                  >
                    <Input
                      value={contraparteSub.matriculaContraparteSub || null}
                      disabled
                      label="Matrícula Contraparte Substituto"
                      placeholder="Nº"
                    />
                    <Input
                      disabled
                      value={contraparteSub.nmContraparteSub || null}
                      label="Contraparte"
                      placeholder="Nome do Contraparte Substituto"
                    />
                    <Input
                      disabled
                      value={contraparteSub.ramalContraparteSub || null}
                      label="Ramal"
                      placeholder="Nº"
                    />
                    <Input
                      disabled
                      value={contraparteSub.emailContraparteSub || null}
                      label="E-mail"
                      placeholder="Endereço de E-mail"
                      required
                    />
                  </Grid>
                )
              })}
            <Grid
              gridCols="1.1fr 2fr 1fr 2.9fr 1.1fr"
              gridGap={`0 ${SPACING.spacing20}`}
              margin={`0 0 ${SPACING.spacing30} 0`}
            >
              <Input
                disabled
                value={contractData.matriculaComprador}
                label="Matrícula Comprador"
                placeholder="Nº"
              />
              <Input
                disabled
                value={contractData.nmComprador}
                label="Comprador"
                placeholder="Nome do Comprador"
              />
              <Input
                value={contractData.ramalComprador}
                disabled
                type="number"
                label="Ramal"
                placeholder="Nº"
              />
              <Input
                value={contractData.emailComprador}
                disabled
                type="email"
                label="E-mail"
                placeholder="Endereço de E-mail"
              />
              <Input
                type="number"
                label="Unidade do Comprador"
                placeholder="Unidade do Comprador"
                formValue="unidadeComprador"
                min={0}
                disabled
              />
            </Grid>
            <Grid
              gridCols="2fr 2fr 2fr 1fr 1fr"
              gridGap={`0 ${SPACING.spacing20}`}
              margin={`0 0 ${SPACING.spacing30} 0`}
            >
              <Input
                disabled
                value={unidadeGestora.diretoriaExecutiva}
                label="Diretoria Executiva"
                placeholder="Diretoria Executiva"
                required
              />
              <Input
                disabled
                label="Diretoria"
                placeholder="Diretoria"
                value={unidadeGestora.diretoria}
              />
              <Input
                disabled
                label="Gerência Geral"
                placeholder="Gerência Geral"
                value={unidadeGestora.gerenciaGeral}
              />
              <Input
                disabled
                label="Gerência"
                placeholder="Gerência"
                value={unidadeGestora.gerencia}
              />
            </Grid>
            <Grid
              gridCols="1fr 2fr 2fr 1fr 2fr"
              gridGap={`0 ${SPACING.spacing20}`}
              margin={`0 0 ${SPACING.spacing30} 0`}
            >
              <Input
                disabled
                value={contractData.cdGrupoMercadoria}
                type="number"
                label="Cód. Grupo Mercadoria"
                placeholder="Cód."
              />
              <Input
                value={null}
                disabled
                label="Tipo Descrição"
                placeholder="Tipo"
                required
              />
              <Input
                disabled
                value={null}
                label="Descrição do Grupo Mercadoria"
                placeholder="Descrição"
                required
              />
              <Input
                value={contractData.cdHierarquiaProd}
                disabled
                type="number"
                label="Cód. Hierarquia Produto"
                placeholder="Cód."
              />
              <Input
                value={null}
                disabled
                label="Descrição Hierarquia Produto"
                placeholder="Descrição"
                required
              />
            </Grid>
            <Grid
              gridCols="8fr "
              gridGap={`0 ${SPACING.spacing20}`}
              margin={`0 0 ${SPACING.spacing30} 0`}
            >
              <ChipInput
                disabled
                defaultValue={contractData.txEmail}
                placeholder=""
                label="E-mail documentação trabalhista"
                only="email"
              />
            </Grid>
            <Grid
              gridCols="8fr"
              gridGap={`0 ${SPACING.spacing20}`}
              margin={`0 0 ${SPACING.spacing5} 0`}
            >
              <Input
                maxLength={1000}
                placeholder="insira uma observação se houver"
                value={contractData.txObservacao}
                label="Observação"
              />
            </Grid>
          </SimpleCollapse>

          <Row justifyContent="flex-end" marginTop={SPACING.spacing20}>
            <Button
              text="Voltar"
              onClick={() => {
                history.goBack()
              }}
              marginLeft={SPACING.spacing20}
            />
          </Row>
        </>
      )}
    </Card>
  )
}
